import React from 'react';
import { FormattedMessage } from 'react-intl';

import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AlertContainer, StyledConfidentialTicketWarning } from '@modules/cap/TicketList/constants/ticketlist.styled';

const ConfidentialTicketAccessDenied = ({ ticketId }: { ticketId?: string | null }) => (
    <AlertContainer>
        <StyledConfidentialTicketWarning
            className="usa-alert gi-alert gi-alert__left-accent gi-alert__warning"
            id="confidential-ticket-access-warning"
            data-testid="confidential-ticket-access-warning"
        >
            <div className="gi-alert__body">
                <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    className="confidential-ticket-access-warning__icon"
                    aria-hidden="true"
                />
                <p className="gi-alert__text">
                    <FormattedMessage
                        id="ticket.sah.msg.confidentialAccessDenied"
                        values={{ ticketId: ticketId ?? '' }}
                    />
                </p>
            </div>
        </StyledConfidentialTicketWarning>
    </AlertContainer>
);

export default ConfidentialTicketAccessDenied;
